module.exports = __webpack_public_path__ + "static/images/0f8c54c4da7a0750db9f01125571f048.svg";